// @ts-check
import { CalendarIcon, PhoneCall, StickyNote, Stethoscope } from "lucide-react";

/**
 * Vocabulário do funil comercial.
 *
 * Espelha `server/src/modules/leads/leads.schemas.js`. As telas de Leads,
 * CRM, Dashboard e WhatsApp leem daqui — antes cada arquivo repetia a lista
 * de etapas, os rótulos de temperatura e o mapa de cores.
 */

/** As 10 colunas do kanban, na ordem. */
export const STAGES = [
  { id: "novo", title: "Novo Lead", tone: "bg-chart-2/15 text-chart-2", dot: "bg-chart-2" },
  { id: "primeiro-contato", title: "Primeiro Contato", tone: "bg-chart-3/15 text-chart-3", dot: "bg-chart-3" },
  { id: "aguardando", title: "Aguardando Resposta", tone: "bg-warning/15 text-warning", dot: "bg-warning" },
  { id: "em-conversa", title: "Em Conversa", tone: "bg-primary/15 text-primary", dot: "bg-primary" },
  { id: "interessado", title: "Interessado", tone: "bg-accent/40 text-accent-foreground", dot: "bg-accent" },
  { id: "agendamento-pendente", title: "Agendamento Pendente", tone: "bg-chart-5/15 text-chart-5", dot: "bg-chart-5" },
  { id: "agendado", title: "Consulta Agendada", tone: "bg-success/15 text-success", dot: "bg-success" },
  { id: "nao-respondeu", title: "Não Respondeu", tone: "bg-muted text-muted-foreground", dot: "bg-muted-foreground" },
  { id: "perdido", title: "Perdido", tone: "bg-destructive/15 text-destructive", dot: "bg-destructive" },
  { id: "recuperacao", title: "Recuperação", tone: "bg-hot/15 text-hot", dot: "bg-hot" },
];

/** @param {string} id */
export const stageById = (id) => STAGES.find((s) => s.id === id) ?? STAGES[0];

// ------------------------------------------------------------- temperatura

export const TEMPERATURES = ["hot", "warm", "cold"];

export const TEMPERATURE_LABELS = { hot: "Quente", warm: "Morno", cold: "Frio" };

export const TEMPERATURE_STYLES = {
  hot: "bg-hot/15 text-hot border-hot/30",
  warm: "bg-warm/15 text-warm-foreground border-warm/30",
  cold: "bg-cold/15 text-cold border-cold/30",
};

export const TEMPERATURE_DOTS = { hot: "bg-hot", warm: "bg-warm", cold: "bg-cold" };

/** Lê a temperatura com segurança quando o dado vem incompleto. */
export const temperatureLabel = (t) => TEMPERATURE_LABELS[t] ?? TEMPERATURE_LABELS.cold;
export const temperatureStyle = (t) => TEMPERATURE_STYLES[t] ?? TEMPERATURE_STYLES.cold;
export const temperatureDot = (t) => TEMPERATURE_DOTS[t] ?? TEMPERATURE_DOTS.cold;

// --------------------------------------------------------------- anotações

/** Os 4 tipos de anotação, com ícone e cor. */
export const NOTE_TYPES = {
  clinico: { label: "Feedback clínico", icon: Stethoscope, tone: "bg-chart-2/15 text-chart-2" },
  ligacao: { label: "Ligação", icon: PhoneCall, tone: "bg-primary/15 text-primary" },
  observacao: { label: "Observação", icon: StickyNote, tone: "bg-warning/15 text-warning" },
  retorno: { label: "Retorno agendado", icon: CalendarIcon, tone: "bg-chart-3/15 text-chart-3" },
};

export const NOTE_TYPE_IDS = Object.keys(NOTE_TYPES);

/** Canais e origens sugeridos no formulário de novo lead. */
export const ORIGIN_SUGGESTIONS = [
  "Meta Ads",
  "Google Ads",
  "Instagram",
  "TikTok",
  "Indicação",
  "Site",
  "Telefone",
];

export const CHANNEL_OPTIONS = ["WhatsApp", "Telefone", "E-mail", "Presencial", "Instagram"];
